import { Image } from '@unistocks/components/basic/image';
import { Column } from '@unistocks/components/layout/flex';
import { useAssetImage } from '@unistocks/features/assets/hooks/use-asset-image';
import { renderValidationIcon } from '@unistocks/features/external-accounts/import/utils';
import {
  getInstrumentValidationError,
  mapInstrumentToAsset
} from '@unistocks/features/external-accounts/utils';
import { InstrumentDto, PortfolioDto } from '@unistocks/proxy/axios-client';
import { t } from '@unistocks/shared/localization/index.ts';
import { ListItem, ListItemProps } from 'tamagui';

export type InstrumentListItemProps = ListItemProps & {
  instrument: InstrumentDto;
  targetPortfolio: PortfolioDto;
};

export const InstrumentListItem: React.FC<InstrumentListItemProps> = ({
  instrument,
  targetPortfolio,
  ...props
}) => {
  const imageUri = useAssetImage(mapInstrumentToAsset(instrument), { preferAssetImage: true });

  return (
    <ListItem cursor="pointer" size={'$5'} gap={'$3'} justifyContent={'flex-start'} {...props}>
      <Image rounded size={'$2.5'} source={imageUri} />
      <Column flex={1}>
        <ListItem.Text>{instrument.name}</ListItem.Text>
        <ListItem.Subtitle>{t('::Enum:AssetType:' + instrument.assetType)}</ListItem.Subtitle>
      </Column>
      {renderValidationIcon(getInstrumentValidationError(instrument, targetPortfolio))}
    </ListItem>
  );
};

InstrumentListItem.displayName = 'InstrumentListItem';
